import { useNavigate, useParams } from "react-router-dom";
import qs from "qs";

export const appRoutes = {
  authLogin: "/auth/login",
  eventList: (isMedia) => `/event/list?isMedia=${isMedia}`,
  // mediaAdd: (eventId) => `/media/add?eventId=${eventId}`,
  // mediaEdit: (id) => `/media/edit/${id}`,
  // mediaDetail: (id) => `/media/detail/${id}`,
  programAdd: (eventId) => `/program/add?eventId=${eventId}`,
  programDetail: (id) => `/program/detail/${id}`,
  programEdit: (id) => `/program/edit/${id}`,
  programEditReport: (id) => `/program/edit/${id}?report=1`,
  programList: ({ userId, eventId, page }) =>
    `/program/list?${qs.stringify({ userId, eventId, page })}`,
  adminProgramList: (status) => `/program/list?status=${status}`,
  userList: "/user/list",
  // mediaList: "/media/list",
  // mediaCards: "/media/cards",
  announcement: "/announcement",
  report: "/report",
  contactUs: "/contactUs",
  home: "/",
  dashboard: "/dashboard",
  guide: "/guide",
  instruction: "/instruction",
  profile: "/profile",
  statistics: "/statistics",
  programData: "/programData",
  statisticalReports: "/StatisticalReports",
  cityList: "/cityList",
  stateList: "/stateList",
  majmooeList: "/majmooeList",
  sazmanList: "/sazmanList",
  monasebatList: "/monasebatList",
  hozeFaaliatList: "/hozeFaaliatList",
  barnameList: "/barnameList",
  onvanList: "/onvanList",
  mozooList: "/mozooList",
  questionList: "/questionList",
};

export const useAppNavigation = () => {
  const navigate = useNavigate();
  const params = useParams();

  return {
    navigate(route) {
      navigate(route);
    },
    params() {
      return params;
    },
    queryParameter() {
      return new URLSearchParams(window.location.search);
    },
  };
};
